export default "__VITE_ASSET__C1lFl1sr__"